import React from 'react'
import { View, StyleSheet } from 'react-native'
import Colors from '../../../constants/Colors'
import { smallTextSize } from '../../../constants/GlobalStyle'
import { Box, Text } from '../../../components/DesignSystem'

export const RequirementTag = ({ isRequired }) => {
	return (
		<Box
			paddingX="sm"
			paddingY="xxs"
			borderRadius="small"
			width="auto"
			marginX="md"
			background="grayTranslucent"
		>
			<Text level="small" weight="medium" tone="tertiary">
				{isRequired ? 'Required' : 'Optional'}
			</Text>
		</Box>
	)
}
